import { ReforestationProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import ForestryIcon from "@ecologi/assets/icons/ProjectInsights/forestry.svg";

export const reforestationVisuals: Record<
  ReforestationProjectType,
  ProjectVisualsType
> = {
  [ReforestationProjectType.Reforestation]: {
    icon: <ForestryIcon />,
    pictogram: `/images/app/forest/carbon_avoidance/pictograms/forestry.svg`,
  },
  [ReforestationProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [ReforestationProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};
